<template>
  <el-container v-title data-title="教职员考勤周报表" style="min-height:98vh">
    <el-header
      style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top />
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF" class="searchDiv">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
                <el-breadcrumb-item>教职员考勤周报表</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="教职员类型">
                  <el-select v-model="searchForm.facultyType" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="老师" value="1"
                      v-if="userInfo.userType === '1' || userInfo.isFacultyAdmin != null && userInfo.isFacultyAdmin"></el-option>
                    <el-option label="教职工" value="2"></el-option>
                    <el-option label="其他" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="选择周">
                  <el-date-picker v-model="weekFirstDay" type="week" format="yyyy 年第 WW 周" placeholder="选择周"
                    :picker-options="{ 'firstDayOfWeek': 1 }">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="isSearching" @click="statFacultyAttendanceByWeek">查询</el-button>
                  <el-button type="primary" :loading="isDownloading"
                    @click="downloadStatFacultyAttendanceByWeek">下载</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" :max-height="tableHeight" border stripe>
          <el-table-column v-for="(title, index) in tableTitleList" :key="index" :prop="title" :label="title"
            :width="(title == '姓名' || title == '迟到早退次数') ? 125 : 170">
            <template slot-scope="scope">
              <span v-if="title == '姓名'">{{scope.row[title]}}</span>
              <span v-if="title == '迟到早退次数'">{{ scope.row[title] }}</span>
              <div v-if="title != '姓名' && title != '迟到早退次数'">
                <div v-if="scope.row[title] != null && scope.row[title][0] != null">
                  <font
                    :style="{color: schoolInfo.signInTimeForFaculty != null && scope.row[title][0] > schoolInfo.signInTimeForFaculty && scope.row[title][0] != '-' ? 'red' : 'black'}"
                    type="text">{{ scope.row[title][0] }}</font>
                </div>
                <div v-if="scope.row[title] != null && scope.row[title][1] != null">
                  <font
                    :style="{color: schoolInfo.signOutTimeForFaculty != null && scope.row[title][1] < schoolInfo.signOutTimeForFaculty && scope.row[title][1] != '-'  ? 'red' : 'black'}"
                    type="text">{{ scope.row[title][1] }}</font>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      schoolInfo: {},
      weekFirstDay: '',
      tableData: [],
      tableTitleList: ['姓名'],
      loading: false,
      searchForm: {
        schoolId: null,
        facultyType: ''
      },
      isSearching: false,
      isDownloading: false,
      tableHeight: 800
    }
  },
  mounted () {
    this.weekFirstDay = this.getMonday()
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
    this.tableHeight = document.documentElement.offsetHeight - document.getElementsByClassName('searchDiv')[0].offsetHeight - 150
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.statFacultyAttendanceByWeek()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    statFacultyAttendanceByWeek () {
      if (this.month === '') return
      let _this = this
      _this.tableTitleList = ['姓名']
      _this.tableData = []
      _this.loading = true
      _this.isSearching = true
      if ((typeof _this.weekFirstDay) === 'object') {
        _this.weekFirstDay = new Date().toISOString().slice(0, 10)
      }
      this.$axios.post(this.GLOBAL.host + '/attendence/statFacultyAttendanceByWeek',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          facultyType: _this.searchForm.facultyType,
          firstDay: _this.weekFirstDay
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            if (res.data.data != null && res.data.data.length > 0) {
              _this.tableTitleList = []
              _this.schoolList.forEach(school => {
                if (_this.searchForm.schoolId != null && _this.searchForm.schoolId === school.id) {
                  _this.schoolInfo = school
                }
              })
              Object.keys(res.data.data[0]).forEach((key) => {
                if (key !== 'userId') {
                  _this.tableTitleList.push(key)
                }
              })
              _this.tableData = res.data.data
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
        _this.isSearching = false
      })
    },
    downloadStatFacultyAttendanceByWeek () {
      if (this.month === '') return
      let _this = this
      _this.isDownloading = true
      this.$axios.post(this.GLOBAL.host + '/attendence/downloadFacultyAttendanceByWeek', this.$qs.stringify({
        schoolId: _this.searchForm.schoolId,
        facultyType: _this.searchForm.facultyType,
        firstDay: _this.weekFirstDay
      }), {
        responseType: 'blob'
      }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
        _this.isDownloading = false
      })
    },
    getMonday () {
      let d = new Date()
      let day = d.getDay()
      let diff = d.getDate() - day + (day === 0 ? -6 : 1)
      return new Date(d.setDate(diff)).toISOString().slice(0, 10)
    }
  }
})
</script>
<style>
  .grid-content {
    min-height: 25px;
    line-height: 25px;
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/AttendenceStatsWeek.vue